import { inject } from '@angular/core';
import { CanActivateFn, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { UserStore } from '../../store/user.store';
import { catchError, map } from 'rxjs/operators';
import { of } from 'rxjs';
import { LOGIN_ROUTE, UNAUTHORIZED_ROUTE } from '../../../app.routes';

export const authGuard: CanActivateFn = (route, state: RouterStateSnapshot) => {
  const userStore = inject(UserStore);
  const router = inject(Router);

  const createLoginUrlTree = (): UrlTree =>
    router.createUrlTree(['/login'], { queryParams: { returnUrl: state.url } });

  if (userStore.currentUser()) {
    return true;
  }

  return userStore.fetchMe().pipe(
    map((user) => (user ? true : createLoginUrlTree())),
    catchError(() => of(createLoginUrlTree())),
  );
};

